import { Template } from "@components/Template";
import { Image } from "@kobalte/core";
import { Show, type VoidComponent, splitProps } from "solid-js";
import { UserIconWrapper } from "./styled";
import type { UserIconsProps } from "./types";

const UserIcon: VoidComponent<UserIconsProps> = (props) => {
	const [locale, others] = splitProps(props, ["src", "alt", "fallback"]);

	return (
		<UserIconWrapper {...others}>
			<Image.Img src={locale.src} alt={locale.alt} />
			<Image.Fallback>
				<Show when={locale.fallback} fallback={<Template w="100%" h="100%" borderRadius="50%" />}>
					{locale.fallback}
				</Show>
			</Image.Fallback>
		</UserIconWrapper>
	);
};
export default UserIcon;
